<template>
    <div class="tc-top-instruments-menu">
        <div>
            <ColorSelectMenu v-if="storeUI.shownTopColorMenu === 'colorFrame'"
                             :colors="colors"
                             :active-color-hex="storeCaseConfiguration.colorFrame"
                             @select="(hex) => selectColor('colorFrame', hex)"/>
            <WorkspaceInstrumentButton @click="showColorMenu('colorFrame')"
                                       title="Основной цвет шкафа">
                <template #icon>
                    <SVGColor1 :color="storeCaseConfiguration.colorFrame"/>
                </template>
            </WorkspaceInstrumentButton>
        </div>
        <div>
            <ColorSelectMenu  v-if="storeUI.shownTopColorMenu === 'colorFace'"
                              :colors="colors"
                              :active-color-hex="storeCaseConfiguration.colorFace"
                              @select="(hex) => selectColor('colorFace', hex)"/>
            <WorkspaceInstrumentButton @click="showColorMenu('colorFace')"
                                       title="Дополнительный цвет шкафа">
                <template #icon>
                    <SVGColor2 :color="storeCaseConfiguration.colorFace"/>
                </template>
            </WorkspaceInstrumentButton>

        </div>
        <WorkspaceInstrumentButton @click="storeCaseConfiguration.switchCloseDoors()"
                                   title="Открыть/Закрыть двери шкафа">
            <template #icon>
                <SVGOpenDoors v-if="storeCaseConfiguration.isCloseDoors"/>
                <SVGCloseDoors v-else/>
            </template>
        </WorkspaceInstrumentButton>
        <WorkspaceInstrumentButton @click="storeCaseConfiguration.switchDecoration()"
                                   :is-active="storeCaseConfiguration.isDecoration"
                                   title="Вкл./Выкл. декоративные элементы">
            <template #icon>
                <SVGDecoration/>
            </template>
        </WorkspaceInstrumentButton>

        <div class="tc-borderline-vertical-top"></div>

        <WorkspaceInstrumentButton @click="saveCase()"
                                   title="Сохранить шкаф">
            <template #icon>
                <SVGSave/>
            </template>
        </WorkspaceInstrumentButton>
        <WorkspaceInstrumentButton @click="openShareModal()"
                                   title="Поделиться конфигурацией">
            <template #icon>
                <SVGShare/>
            </template>
        </WorkspaceInstrumentButton>
        <WorkspaceInstrumentButton @click="openModalDeleteAlert()"
                                   title="Удалить шкаф">
            <template #icon>
                <SVGDeleteCase/>
            </template>
        </WorkspaceInstrumentButton>
    </div>
</template>

<script>
import WorkspaceInstrumentButton from '@/UI/Workspace/WorkspaceInstrumentButton.vue';
import SVGSave from '@/UI/SVG/SVGSave.vue';
import SVGShare from '@/UI/SVG/SVGShare.vue';
import SVGDeleteCase from '@/UI/SVG/SVGDeleteCase.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreNotifications } from '@/Store/storeNotifications';
import SVGColor1 from '@/UI/SVG/SVGColor1.vue';
import SVGColor2 from '@/UI/SVG/SVGColor2.vue';
import SVGOpenDoors from '@/UI/SVG/SVGOpenDoors.vue';
import SVGCloseDoors from '@/UI/SVG/SVGCloseDoors.vue';
import SVGDecoration from '@/UI/SVG/SVGDecoration.vue';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import ColorSelectMenu from '@/UI/Workspace/ColorSelectMenu.vue';
import { colors } from '@/Constants/colors';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { saveCase } from '@/libs/saveCase';

export default {
    name: 'TopInstrumentsMenu',
    computed: {
        colors() {
            return colors;
        },
    },
    components: {
        ColorSelectMenu,
        SVGDecoration,
        SVGCloseDoors,
        SVGOpenDoors,
        SVGColor2,
        SVGColor1,
        SVGDeleteCase,
        SVGShare,
        SVGSave,
        WorkspaceInstrumentButton,
    },
    setup() {
        const storeUI = useStoreUI();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storeNotifications = useStoreNotifications();
        const storeProjectStructure = useStoreProjectStructure();

        return {
            storeUI,
            storeCaseConfiguration,
            storeNotifications,
            storeProjectStructure,
        };
    },
    methods: {
        showColorMenu(colorName) {
            const selectedMenu = this.storeUI.shownTopColorMenu;
            if (selectedMenu === colorName) {
                this.storeUI.setShownTopColorMenu();
            } else {
                this.storeUI.setShownTopColorMenu(colorName);
            }
        },
        selectColor(colorName, color) {
            if (colorName === 'colorFrame') {
                this.storeCaseConfiguration.setColorFrame(color.hex);
            }else if (colorName === 'colorFace') {
                this.storeCaseConfiguration.setColorFace(color.hex);
            }
            this.storeUI.setShownTopColorMenu();
        },
        saveCase,
        openShareModal() {
            this.storeUI.setActiveModalName('share');
            this.storeUI.setIsShowModal(true);
        },
        openModalDeleteAlert() {
            this.storeUI.setActiveModalName('deleteCaseAlert');
            this.storeUI.setIsShowModal(true);
        },
    },
};
</script>

<style scoped lang="scss">
.tc-top-instruments-menu {
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: max-content;
    height: max-content;
    justify-content: center;
    align-items: center;
    position: relative;
}

.tc-borderline-vertical-top {
    height: 40px;
    box-sizing: border-box;
    width: 1px;
    background-color: #D9D9D9;
}
</style>
